<div class="ct-textarea-component"
     [class.ct-can-resize]="canResize"
     [class.ct-focused]="isFocusClassShown">
    <div class="ct-textarea-container" slimScroll #slimScroll='slimScroll' [ctSlimScrollArrows]="slimScroll">
                <textarea [name]="name" #autoSizer="cdkTextareaAutosize" cdkTextareaAutosize
                          [maxlength]="maxlength"
                          [placeholder]="placeholder"
                          [disabled]="disabled"
                          (blur)="isFocusClassShown = false"
                          (focus)="isFocusClassShown = true"
                          class="ct-textarea"
                          [(ngModel)]="modelValue"
                          (ngModelChange)="updateModel(modelValue)"></textarea>
    </div>
</div>
